// ...existing code...
import { Stack,Autocomplete, TextField, Select, MenuItem, FormControl, InputLabel, Box, Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
// Adicione a importação do hook para buscar clientes
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getClients, saveClient } from "../../services/clientService";
import { useCompany } from "../../contexts/CompanyContext"
import { opcoesTipoProjeto } from "../../constants/opcoesPricing";


const StepDadosCliente = ({ formData, updateFormData }) => {
    const [clientes, setClientes] = useState([]);
    const {company} = useCompany()
    const [open, setOpen] = useState(false);
    const [novoCliente, setNovoCliente] = useState({ name: "", address: "", phone: "", email: "" });


  useEffect(() => {
    async function fetchClientes() {
        if (company?.companyId) {
            const lista = await getClients(company.companyId); 
            setClientes(lista || []);
        }
    }
    fetchClientes();
  }, [company?.companyId, open]);

  const handleAddCliente = async () => {
      if (company?.companyId && novoCliente.name) {
          await saveClient(company.companyId, novoCliente);
          setOpen(false);
          setNovoCliente({ name: "", address: "", phone: "", email: "" });
      }
  };

  return (
    <Box>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <Autocomplete
            options={clientes}
            getOptionLabel={(option) => option.name || ""}
            value={formData.dadosCliente || null}
            onChange={(_, value) => updateFormData("dadosCliente", value)}
            renderInput={(params) => <TextField {...params} label="Cliente" />}
            sx={{ flex: 1 }}
        />
        <Button variant="contained" onClick={() => setOpen(true)}>
            + Adicionar Cliente
        </Button>
      </Stack>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Novo Cliente</DialogTitle>
        <DialogContent>
          <TextField
            label="Nome"
            fullWidth
            margin="normal"
            value={novoCliente.name}
            onChange={e => setNovoCliente({ ...novoCliente, name: e.target.value })}
          />
          <TextField
            label="Endereço"
            fullWidth
            margin="normal"
            value={novoCliente.address}
            onChange={e => setNovoCliente({ ...novoCliente, address: e.target.value })}
          />
          <TextField
            label="Telefone"
            fullWidth
            margin="normal"
            value={novoCliente.phone}
            onChange={e => setNovoCliente({ ...novoCliente, phone: e.target.value })}
          />
          <TextField
            label="Email"
            fullWidth
            margin="normal"
            value={novoCliente.email}
            onChange={e => setNovoCliente({ ...novoCliente, email: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button onClick={handleAddCliente} variant="contained">Salvar</Button>
        </DialogActions>
      </Dialog>
      <TextField
        label="Nome do Projeto"
        value={formData.nomeProjeto || ""}
        onChange={(e) => updateFormData("nomeProjeto", e.target.value)}
        fullWidth
        sx={{ mb: 2 }}
      />
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Tipo de Projeto</InputLabel>
        <Select
          label="Tipo de Projeto"
          value={formData.tipoProjeto || ""}
          onChange={(e) => updateFormData("tipoProjeto", e.target.value)}
        >
          {opcoesTipoProjeto.map((tipo) => (
            <MenuItem key={tipo} value={tipo}>{tipo}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
StepDadosCliente.propTypes = {
  formData: PropTypes.object.isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default StepDadosCliente;